import { render, staticRenderFns } from "./InlineBoxWorkflow.vue?vue&type=template&id=53cc2800&scoped=true"
import script from "./InlineBoxWorkflow.vue?vue&type=script&lang=js"
export * from "./InlineBoxWorkflow.vue?vue&type=script&lang=js"
import style0 from "./InlineBoxWorkflow.vue?vue&type=style&index=0&id=53cc2800&prod&lang=scss"
import style1 from "./InlineBoxWorkflow.vue?vue&type=style&index=1&id=53cc2800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc2800",
  null
  
)

export default component.exports